import {TooltipModule} from '../../../../tooltip/tooltip.module';
import {CommonSectionsModule} from '../../../common/common-sections.module';
import {KycPreferenceComponent} from './kyc-preference/kyc-preference.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvestmentInitialRoutingModule} from './investment-initial-routing.module';
import {InvestPerferenceComponent} from './invest-perference/invest-perference.component';
import { AddFundPopupModule } from '../add-fund-popup/add-fund-popup.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IndianCurrencyFormatterModule } from '../../../common/indian-currency-formatter/indian-currency-formatter.module';
import { MatSlideToggleModule, MatCheckboxModule, MatExpansionModule, MatSliderModule } from '@angular/material';
import { NCashAllocationComponent } from '../nCash-allocation/nCash-allocation.component';
import { ViewSwiftAllocationComponent } from '../view-swift-allocation/view-swift-allocation.component';
import { InitiateWithdrawalPopupModule } from '../initiate-withdrawal-popup/initiate-withdrawal-popup.module';
import { ConfirmWithdrawalPopupModule } from '../confirm-withdrawal-popup/confirm-withdrawal-popup.module';


@NgModule({
  declarations: [
    KycPreferenceComponent,
    InvestPerferenceComponent,
    NCashAllocationComponent,
    ViewSwiftAllocationComponent
  ],
  imports: [
    CommonModule,
    InvestmentInitialRoutingModule,
    CommonSectionsModule,
    TooltipModule,
    AddFundPopupModule,
    InitiateWithdrawalPopupModule,
    FormsModule,
    ReactiveFormsModule,
    IndianCurrencyFormatterModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatSliderModule,
    ConfirmWithdrawalPopupModule
  ]
})
export class InvestmentInitialModule { }
